const log = require("Sources/utils/logger")();

module.exports = class ObjectSelector {
  constructor(options) {
    this.key = options.key;
    this.name = options.name;
    this.containerElement = options.containerElement;
    this.onClickCallback = options.onClickCallback;
    this.isActive = options.isActive;

    this.create();
  }

  create() {
    let that = this;
    let element = $("<a class='object-selector'>" + this.name + "</a>").attr("data-object-key", this.key);
    element.on("click", function () {
      that.setActive();
      that.onClickCallback(that.key);
    });

    this.containerElement.append(element);
    this.element = element;

    if (this.isActive) this.setActive();
  }

  setActive() {
    this.containerElement.find(".object-selector").each(function () {
      $(this).removeClass("active");
    });

    this.element.addClass("active");
  }
};



// WEBPACK FOOTER //
// ./app/js/components/cms/object-selector.js